<template lang="pug">
  .contentpage.two-cols
    .header-area(v-if="areas.header && areas.header.length")
      section(v-for="(section, index) in areas.header" :key="section.id" :class="section.key" v-if="index === 0")
        Banner(v-if="section.key === 'banner'" :section="section")
        Slider(v-if="section.key === 'slider'" :section="section")
    .main-area(v-if="areas.main1 && areas.main1.length || areas.main2 && areas.main2.length")
      section.container.mx-auto.flex
        .col.col1
          section(v-for="(section, index) in areas.main1" :key="section.id" :class="section.key")
            Heading(v-if="section.key === 'heading'" :section="section")
            Post(v-if="section.key === 'post'" :section="section")
            ColSize(v-if="section.key === 'col-size'" :section="section")
            ImageSection(v-if="section.key === 'image'" :section="section")
            Form(v-if="section.key === 'form'" :section="section")
            Downloads(v-if="section.key === 'downloads'" :section="section")
        .col.col2
          section(v-for="(section, index) in areas.main2" :key="section.id" :class="section.key")
            Heading(v-if="section.key === 'heading'" :section="section")
            Post(v-if="section.key === 'post'" :section="section")
            ImageSection(v-if="section.key === 'image'" :section="section")
            Form(v-if="section.key === 'form'" :section="section")
            Downloads(v-if="section.key === 'downloads'" :section="section")
</template>

<script>
import Page from '@/views/Page';
import Heading from '@/components/Heading';
import Slider from '@/components/Slider';
import Post from '@/components/Post';
import Banner from '@/components/Banner';
import ColSize from '@/components/ColSize';
import ImageSection from '@/components/ImageSection';
import Form from '@/components/Form';
import Downloads from '@/components/Downloads';

export default {
    name: 'ContentPage2Cols',
    extends: Page,
    components: {
        Heading,
        Slider,
        Post,
        Banner,
        ColSize,
        ImageSection,
        Form,
        Downloads
    }
};
</script>

<style lang="sass">
section.container
  @apply mt-8 flex-col
  @screen sm
    @apply flex-row mt-16
  .col1
    @apply mr-12
  @media screen and (max-width:640px)
    .col
      width: 100% !important
      margin-right: 0 !important
    .col1
      @apply mb-8


section.slider,
section.banners
  padding: 0
section.heading
  padding-bottom: 0
</style>
